import PhotoSwipeLightbox from 'https://cdn.jsdelivr.net/npm/photoswipe@5.4.4/dist/photoswipe-lightbox.esm.min.js';

const root = document.getElementById('lfj-gallery');
if (!root) throw new Error('no gallery');
const edition = root.dataset.edition;
const member = root.dataset.member === 'true';
const opened = Date.now();
const track = (name, data = {}) => {
  const payload = { edition, member, ...data };
  try { window.Shopify && Shopify.analytics && Shopify.analytics.publish('lfj:' + name, payload); } catch (e) {}
  if (window.LFJ_DEBUG) console.log('[lfj]', name, payload);
};

/* fade each photo in once it has loaded */
root.querySelectorAll('.lg-frame img').forEach(img => {
  const ready = () => img.classList.add('is-ready');
  if (img.complete && img.naturalWidth) ready(); else img.addEventListener('load', ready, { once: true });
});

/* no saving: context menu, drag, long-press */
root.addEventListener('contextmenu', e => { if (e.target.closest('img,.lg-frame')) e.preventDefault(); });
root.addEventListener('dragstart', e => e.preventDefault());
document.addEventListener('contextmenu', e => { if (e.target.closest('.pswp')) e.preventDefault(); });

/* tracking: landing (with QR tags), views, clicks, time */
const qs = new URLSearchParams(location.search);
track('gallery_opened', { utm_source: qs.get('utm_source'), utm_medium: qs.get('utm_medium'), utm_campaign: qs.get('utm_campaign') });
if (qs.get('utm_medium') === 'qr') track('qr_landing', { campaign: qs.get('utm_campaign') });
const titleOf = (n) => { const a = root.querySelector('.lg-frame[data-plate="' + n + '"]'); return a && a.dataset.captionTitle ? a.dataset.captionTitle : 'Photograph ' + n + ' (locked)'; };
const seen = new Set();
let furthest = 0;
const io = new IntersectionObserver(entries => entries.forEach(en => {
  if (en.isIntersecting) { const n = en.target.dataset.plate; if (!seen.has(n)) { seen.add(n); if (+n > furthest) furthest = +n; track('photo_viewed', { plate: +n, photo: titleOf(n), locked: en.target.classList.contains('is-locked') }); } }
}), { threshold: 0.6 });
root.querySelectorAll('.lg-plate').forEach(el => io.observe(el));
root.addEventListener('click', e => {
  const t = e.target.closest('[data-track]');
  if (!t) return;
  track(t.dataset.track, { plate: t.dataset.plate ? +t.dataset.plate : undefined, href: t.getAttribute('href') });
  if (t.classList.contains('lg-lock')) document.getElementById('lg-join')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
});
let sent = false;
const leave = () => { if (sent) return; sent = true; track('time_on_gallery', { seconds: Math.round((Date.now() - opened) / 1000), photos_seen: seen.size, furthest_photo: furthest, photos_total: root.querySelectorAll('.lg-plate').length }); };
document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'hidden') leave(); });
window.addEventListener('pagehide', leave);

/* the viewer */
const lightbox = new PhotoSwipeLightbox({
  gallery: '#lg-plates',
  children: 'a.lg-frame',
  pswpModule: () => import('https://cdn.jsdelivr.net/npm/photoswipe@5.4.4/dist/photoswipe.esm.min.js'),
  bgOpacity: 1,
  showHideAnimationType: 'zoom',
  wheelToZoom: true,
  imageClickAction: 'zoom',
  tapAction: 'toggle-controls',
  doubleTapAction: 'zoom',
  bgClickAction: 'close',
  initialZoomLevel: 'fit',
  secondaryZoomLevel: (zl) => Math.min(1, zl.fit * 2.5),
  maxZoomLevel: (zl) => Math.max(1, zl.fit * 4),
  padding: { top: 0, bottom: 0, left: 0, right: 0 },
  preload: [1, 2],
  counter: true,
  zoom: false
});
lightbox.on('uiRegister', () => {
  lightbox.pswp.ui.registerElement({
    name: 'lg-caption', order: 9, isButton: false, appendTo: 'root', className: 'lg-pswp-cap',
    onInit: (el, pswp) => {
      const update = () => {
        const a = pswp.currSlide && pswp.currSlide.data && pswp.currSlide.data.element;
        el.innerHTML = a ? '<b>' + (a.dataset.captionTitle || '') + '</b><span>' + (a.dataset.captionText || '') + '</span>' : '';
      };
      pswp.on('change', update); update();
    }
  });
});
let maxZoomSeen = 0;
const plateOf = () => { const s = lightbox.pswp && lightbox.pswp.currSlide; return s && s.data && s.data.element ? +s.data.element.dataset.plate : undefined; };
lightbox.on('change', () => { const n = plateOf(); track('photo_opened', { plate: n, photo: titleOf(n) }); });
lightbox.on('zoomPanUpdate', ({ slide }) => {
  if (!slide || !slide.currZoomLevel) return;
  const pct = Math.round(slide.currZoomLevel * 100);
  if (slide.currZoomLevel > slide.zoomLevels.fit * 1.05 && pct > maxZoomSeen + 10) {
    maxZoomSeen = pct;
    track('photo_zoomed', { plate: +slide.data.element.dataset.plate, photo: titleOf(slide.data.element.dataset.plate), zoom_percent_of_original: pct });
  }
});
lightbox.init();
